// src/components/planner/modals/ReviewContentModal.tsx

import React, { useState } from 'react';
import { X, Save } from 'lucide-react';

const API_BASE_URL = '/api';

interface ReviewContentModalProps {
    onClose: () => void;
    onSave: () => void;
    onShowToast: (message: string, type: 'success' | 'error' | 'info') => void;
}

const ReviewContentModal: React.FC<ReviewContentModalProps> = ({
    onClose,
    onSave,
    onShowToast
}) => {
    const [formData, setFormData] = useState({
        content: '',
        studyDate: new Date().toISOString().split('T')[0],
        studyType: ''
    });

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!formData.content.trim()) {
            onShowToast('Preencha o conteúdo estudado', 'error');
            return;
        }

        try {
            const token = localStorage.getItem('accessToken');
            const response = await fetch(`${API_BASE_URL}/planner/review-contents`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                onShowToast('Conteúdo adicionado!', 'success');
                onSave();
            } else {
                onShowToast('Erro ao adicionar', 'error');
            }
        } catch (error) {
            onShowToast('Erro ao adicionar', 'error');
        }
    };

    return (
        <div className="plnr-modal-overlay" onClick={onClose}>
            <div className="plnr-modal" onClick={(e) => e.stopPropagation()}>
                <div className="plnr-modal-header">
                    <h3>Adicionar Conteúdo para Revisão</h3>
                    <button className="plnr-modal-close" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="plnr-modal-body">
                        <div className="plnr-hint-box">
                            <p>
                                Ao adicionar um conteúdo, automaticamente criaremos sugestões de revisão
                                nos intervalos: 3 dias, 7 dias, 15 dias e 30 dias.
                            </p>
                        </div>

                        <div className="plnr-form-group">
                            <label>Conteúdo estudado *</label>
                            <input
                                type="text"
                                value={formData.content}
                                onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                                placeholder="Ex: Cardiologia - Insuficiência Cardíaca"
                                className="plnr-input"
                                required
                            />
                        </div>

                        <div className="plnr-form-group">
                            <label>Data do estudo *</label>
                            <input
                                type="date"
                                value={formData.studyDate}
                                onChange={(e) => setFormData({ ...formData, studyDate: e.target.value })}
                                className="plnr-input"
                                required
                            />
                        </div>

                        <div className="plnr-form-group">
                            <label>Tipo de estudo (opcional)</label>
                            <input
                                type="text"
                                value={formData.studyType}
                                onChange={(e) => setFormData({ ...formData, studyType: e.target.value })}
                                placeholder="Ex: Flashcards, Leitura, Questões..."
                                className="plnr-input"
                            />
                        </div>
                    </div>

                    <div className="plnr-modal-footer">
                        <button type="button" className="plnr-btn secondary" onClick={onClose}>
                            Cancelar
                        </button>
                        <button type="submit" className="plnr-btn primary">
                            <Save size={16} />
                            Adicionar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ReviewContentModal;